const METHODS = [
  { id: 'verbal',             label: 'Verbal' },
  { id: 'ecrit_signature',    label: 'Écrit signé' },
  { id: 'email_pre_session',  label: 'Email avant la séance' },
]

export default function ConsentStep({ value, onChange }) {
  return (
    <div className="max-w-[680px] space-y-5">
      <label className="flex items-start gap-3 rounded-xl border border-line bg-white p-4 text-[14px] leading-snug">
        <input
          type="checkbox"
          checked={!!value.consent_given}
          onChange={(e) => onChange({ ...value, consent_given: e.target.checked })}
          className="mt-1 h-4 w-4 accent-terra-500"
        />
        <span>
          <strong className="font-semibold">Le client a été informé</strong> de l'enregistrement et donne son consentement.
        </span>
      </label>

      <div>
        <div className="mb-2 text-[12px] uppercase tracking-[1.4px] text-muted">Méthode de recueil</div>
        <div className="flex flex-wrap gap-2">
          {METHODS.map(m => {
            const on = value.consent_method === m.id
            return (
              <button
                type="button"
                key={m.id}
                onClick={() => onChange({ ...value, consent_method: m.id })}
                className={`rounded-full border px-3 py-1.5 text-[12.5px] ${on ? 'border-ink bg-ink text-white' : 'border-line bg-white text-ink hover:border-terra-500'}`}
              >
                {m.label}
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
